import { BaseEventTracking } from '/@/modules/core/app/models/abstracts/BaseEventTracking';
import { SegmentEvent } from '/@/integrations/segment/SegmentEvent';

export class DiagnosticToolShareClickedEventTracking extends BaseEventTracking {
  static eventName: SegmentEvent = SegmentEvent.DIAGNOSTIC_TOOL_SHARE_CLICKED;

  formId: string;

  constructor(formId: string) {
    super();
    this.formId = formId;
  }
}
